$(function() {

    $(window).scroll(function(){
        if($(window).scrollTop() >= ($('.footer').offset().top - $(window).height()))
        {
            $('.reservation-devis').removeClass('sticky');
            $('.reservation-devis').addClass('bottom');
            $('.product-content').css('padding-bottom', 0);
        }
        else if ($(window).scrollTop() >= ($('.product-content').offset().top - $('.reservation-devis').height())) {
            $('.reservation-devis').addClass('sticky');
            $('.reservation-devis').removeClass('bottom');
            $('.product-content').css('padding-bottom', $('.reservation-devis').height() + 40);
        }
        else {
            $('.reservation-devis').removeClass('sticky');
            $('.reservation-devis').removeClass('bottom');
            $('.product-content').css('padding-bottom', 0);
        }
    });

    $('#reservation-devis-buttons-tel').click(function(){
        $(this).toggleClass('active');
    });

    $('.slick-slider-top').on('init reInit beforeChange', function(event, slick, currentSlide, nextSlide){
        var i = (nextSlide ? nextSlide : 0) + 1;
        $('.slider-index').text(i);
        $('.slider-count').text(slick.slideCount);
        $('.slider-arrow').addClass('active');
    });

    $('.slick-slider-top').slick({
        appendArrows: $('.slider-arrow'),
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg class="icon icon-arrow"></svg><span class="sr-only">Visuel précédent</span></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg class="icon icon-arrow"></svg><span class="sr-only">Visuel suivant</span></button>',
    });

    $('.slider-sync-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-sync'
    });

    $('.slider-sync').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.slider-sync-for',
        dots: false,
        centerMode: true,
        focusOnSelect: true
    });
});